import { HTTP } from '@/services/axios';

export async function getTasks({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/customWorking/WorkingTasks/getTaskList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getTask({taskId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/customWorking/WorkingTasks/getTaskData.php?taskId=${taskId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function getTaskItem({taskItemId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/customWorking/WorkingTasks/getTaskItemData.php?taskItemId=${taskItemId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getTaskTypeOptions(){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: '/app/customWorking/WorkingTasks/getTaskTypeOptions.php'
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getTaskAccountStatesOptions(){
    let result = {};
    var bodyFormData = new FormData();
    
    await HTTP({
        method: 'get',
        url: '/app/customWorking/WorkingTasks/getTaskAccountStatesOptions.php',
        data: bodyFormData
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function getTaskItemTypeOptions(){
    let result = {};
    
    await HTTP({
        method: 'get',
        url: '/app/customWorking/WorkingTasks/getTaskItemTypeOptions.php'
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getTaskItemStatesOptions(){
    let result = {};
    
    await HTTP({
        method: 'get',
        url: '/app/customWorking/WorkingTasks/getTaskItemStatesOptions.php'
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createTask({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/customWorking/WorkingTasks/controlTaskSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveTask({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/customWorking/WorkingTasks/controlTaskSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createTaskItem({taskId,data}){
    let result = {};

    var bodyFormData = new FormData();
	bodyFormData.set('taskId',taskId);
	bodyFormData.set('data',JSON.stringify(data));
    var datas = {'taskId':taskId,'data':data}
    
    await HTTP({
        method: 'post',
        url: '/app/customWorking/WorkingTasks/controlTaskItemSave.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveTaskItem({taskId,data}){
    let result = {};

    var bodyFormData = new FormData();
	bodyFormData.set('taskId',taskId);
	bodyFormData.set('myData',JSON.stringify(data));
    var datas = {'taskId':taskId,'data':data}
    
    await HTTP({
        method: 'put',
        url: '/app/customWorking/WorkingTasks/controlTaskItemSave.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteTask({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/customWorking/WorkingTasks/controlTaskDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteTaskItem({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/customWorking/WorkingTasks/controlTaskItemDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}